import {INameExternalId} from "@/models/interfaces/INameExternalId";
import {IDoctor} from "@/models/interfaces/IDoctor";
import {IMedicalField} from "@/models/interfaces/IMedicalField";
import {SelectListItem} from "@reapptor-apps/reapptor-react-components";

type CollectionItem = INameExternalId | IDoctor | IMedicalField;
export function toSelectListItem<T extends CollectionItem>(item: T): SelectListItem {
  const selectedItem = new SelectListItem();
  selectedItem.ref = item;
  selectedItem.value = item.id;
  selectedItem.text = item.name;
  return selectedItem;
}
